import React from "react";
import { Panel, COLORS } from "./ui";

const STEP_COLORS = [COLORS.indigo, COLORS.indigoSoft, COLORS.purple, COLORS.sky, COLORS.emerald];

/** data: [{ step, count }] in funnel order (top = most, bottom = least). */
const BookingFunnel = ({ data, loading, error, onRetry }) => {
  const max = data && data.length ? data[0].count : 0;

  return (
    <Panel
      eyebrow="המרה"
      title="משפך המרה של הזמנת שיעור פרטי"
      subtitle="מבקשה ראשונית ועד לשיעור שהתקיים"
      accent="emerald"
      loading={loading}
      error={error}
      onRetry={onRetry}
      empty={!loading && !error && (!data || data.length === 0)}
    >
      <div className="space-y-2 py-1">
        {data?.map((step, i) => {
          const widthPct = Math.max(18, Math.round((step.count / max) * 100));
          const prev = i > 0 ? data[i - 1].count : step.count;
          const stepConversion = i === 0 ? 100 : Math.round((step.count / prev) * 100);
          const dropOff = 100 - stepConversion;

          return (
            <div key={step.step} className="flex items-center gap-3">
              <div className="w-24 sm:w-28 flex-shrink-0 text-left">
                <p className="text-xs font-bold text-gray-800">{step.count}</p>
                {i > 0 && <p className="text-[10px] text-rose-500 font-semibold">נטישה {dropOff}%</p>}
              </div>
              <div className="flex-1">
                <div
                  className="h-8 sm:h-9 rounded-lg flex items-center justify-center text-white text-[11px] font-bold shadow-sm transition-all"
                  style={{ width: `${widthPct}%`, minWidth: "40%", backgroundColor: STEP_COLORS[i % STEP_COLORS.length] }}
                >
                  {step.step}
                </div>
              </div>
              <div className="w-12 flex-shrink-0 text-[11px] font-bold text-gray-400">
                {i > 0 ? `${stepConversion}%` : ""}
              </div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};

export default BookingFunnel;
